import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../components/Sidebar";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";

const CourseManager = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(20);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [userRole, setUserRole] = useState(localStorage.getItem("userData"));

  useEffect(() => {
    if (localStorage.getItem("userData")) {
      setUserRole(JSON.parse(localStorage.getItem("userData")))
    }
  }, [])

  const navigate = useNavigate()

  const handleSearch = () => {
    let filtered = data;

    if (searchQuery) {
      filtered = filtered.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    if (startDate) {
      filtered = filtered.filter((item) => new Date(item.date) >= new Date(startDate));
    }
    if (endDate) {
      filtered = filtered.filter((item) => new Date(item.date) <= new Date(endDate));
    }
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStartDate("");
    setEndDate("");
    setFilteredData(data);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const fetchData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-all-courses`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
    setData(response?.data?.users);
    setFilteredData(response?.data?.users);
  };

   const fileInputRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  // Handle closing the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Handle confirming the deletion
  const confirmDeletion = async () => {
    await axios.delete(`${process.env.REACT_APP_BASE_URL}/delete-course/${deleteId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
    fetchData()
    setDeleteId("")
    closeModal();
  };
  const handleButtonClick = () => {
    fileInputRef.current.click(); // Opens file picker
  };
    const handleFileChange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
  
      const formData = new FormData();
      formData.append("file", file);
  
      try {
        await axios.post(`${process.env.REACT_APP_BASE_URL}/bulk-upload-courses`, formData, {
          headers: { 
            "Content-Type": "multipart/form-data",
            Authorization: `${localStorage.getItem("token")}`,
           },
        });
        fetchData()
      } catch (error) {
        console.error("Upload Error:", error);
      }
    };
  return (
    <div className="min-h-screen flex bg-gray-100">
      <Sidebar />

      <div className="flex-1 p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-black">Course Manager</h1>
          {(userRole?.role === "admin" || userRole?.managers?.["Course Manager"]?.add) && <div className="flex gap-4"> <NavLink
            to="/add-course"
            className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
          >
            + Add Course
          </NavLink>
          <input 
        type="file" 
        accept=".xlsx, .csv" 
        ref={fileInputRef} 
        onChange={handleFileChange} 
        style={{ display: "none" }} 
      />
            <button
              className="bg-orange text-white px-6 py-2 rounded-md shadow-md"
              onClick={handleButtonClick}
            >
              Upload CSV
            </button>
        </div>}
        </div>

        <div className="bg-white p-4 shadow-md rounded-lg mb-6 flex items-center gap-4">
          <input
            type="text"
            placeholder="Search by course name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="border border-gray-300 rounded-md px-4 py-2 w-1/4"
          />
          {/* <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border border-gray-300 rounded-md px-4 py-2"
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border border-gray-300 rounded-md px-4 py-2"
          /> */}
          <button
            onClick={handleSearch}
            className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
          >
            Search
          </button>
          <button
            onClick={handleReset}
            className="bg-orange text-white px-6 py-2 rounded-md shadow-md"
          >
            Reset
          </button>
        </div>

        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
          <table className="table-auto w-full">
            <thead className="bg-blue text-white">
              <tr>
                <th className="px-4 py-2" onClick={() => handleSort("id")}>
                  ID {sortConfig.key === "id" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                </th>
                <th className="px-4 py-2" onClick={() => handleSort("name")}>
                  Course Name {sortConfig.key === "name" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                </th>
                <th className="px-4 py-2" onClick={() => handleSort("date")}>
                  Date {sortConfig.key === "date" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                </th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.map((course, index) => (
                <tr key={course._id} className="border-b">
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2">{course.name}</td>
                  <td className="px-4 py-2">{new Date(course.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' })}</td>
                  <td className="px-4 py-2">
                    <button className="bg-green-500 text-white px-4 py-1 rounded-md shadow-md" onClick={() => {
                      navigate("/view-course", {
                        state: {
                          type: "view",
                          data: course
                        }
                      })
                    }}>
                      View
                    </button>
                    {(userRole?.role === "admin" || userRole?.managers?.["Course Manager"]?.add) && <><button className="bg-orange text-white px-4 py-1 ml-2 rounded-md shadow-md" onClick={() => {
                      navigate("/edit-course", {
                        state: {
                          type: "edit",
                          data: course
                        }
                      })
                    }}>
                      Edit
                    </button>
                    <button className="bg-red-500 text-white px-4 py-1 ml-2 rounded-md shadow-md" onClick={()=>{
                      setDeleteId(course?._id)
                      openModal()}
                      }>
                      Delete
                    </button></>}
                  </td>
                </tr>
              ))}
              {currentRows.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center py-4 text-gray-500">
                    No courses found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between items-center mt-4">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded-md ${currentPage === 1 ? "bg-gray-300" : "bg-blue text-white"}`}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 rounded-md ${currentPage === totalPages ? "bg-gray-300" : "bg-blue text-white"}`}
          >
            Next
          </button>
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-lg font-semibold">Are you sure you want to delete?</h2>
            <div className="mt-4 flex justify-center space-x-4">
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded-md"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded-md"
                onClick={confirmDeletion}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CourseManager